import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import axios from "axios";

function ManagerCreateClass() {
    const { t } = useTranslation();
    const { user } = useAuth();

    // State Yönetimi
    const [sections, setSections] = useState([]);
    const [teachers, setTeachers] = useState([]);
    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Form verilerini tek bir state'te tutuyoruz (Controlled Component)
    const [formData, setFormData] = useState({
        className: "",
        description: "",
        lecturerId: "",
        sectionId: ""
    });

    // İnput değişikliklerini dinleyen fonksiyon
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setMsg(""); // Önceki hataları temizle

        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user.token
            };

            let url = "https://api.heryerdeingilizce.com/api/manager/EditSchool/CreateClass";

            const res = await axios.post(url, {
                isDeleted: false,
                schoolId: user.userDetail.schoolId,
                className: formData.className,
                description: formData.description,
                lecturerId: formData.lecturerId,
                sectionId: formData.sectionId
            }, { headers: headerss });

            if (res.status === 200 && res.data['success']) {
                Swal.fire({
                    title: "Başarılı!",
                    text: "Sınıf başarıyla oluşturuldu.",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false
                });

                // Başarılı kayıttan sonra formu sıfırla (Sayfa yenilemeye gerek yok)
                setFormData({
                    className: "",
                    description: "",
                    lecturerId: "",
                    sectionId: ""
                });
            } else {
                setMsg(res.data['message'] || "İşlem başarısız oldu.");
                Swal.fire("Hata", res.data['message'] || "İşlem başarısız oldu.", "error");
            }
        } catch (err) {
            Swal.fire("Hata", err.message, "error");
        } finally {
            setIsSubmitting(false);
        }
    }

    useEffect(() => {
        const fetchInitialData = async () => {
            setLoading(true);
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user.token
            };

            try {
                // 1. Bölümleri (Sections) Çekme
                const sectionsRes = await axios.get("https://api.heryerdeingilizce.com/api/user/Content/GetCourse", { headers: headerss });
                console.log("Bölümler API Yanıtı:", sectionsRes);
                if (sectionsRes.status === 200 && sectionsRes.data['success']) {
                    // push yerine filter ve map ile temiz bir dizi oluşturup state'e atıyoruz
                    const activeSections = sectionsRes.data.data.courses
                        .filter(s => !s.isDeleted && s.isActive)
                        .map(s => ({
                            id: s.id,
                            sectionName: s.courseName,
                            sectionDescription: s.courseDesc
                        }));
                    setSections(activeSections);
                } else {
                    setMsg(sectionsRes.data['message']);
                }

                // 2. Öğretmenleri (Lecturers) Çekme
                const teachersRes = await axios.get("https://api.heryerdeingilizce.com/api/manager/EditSchool/GetLecturers", { headers: headerss });
                if (teachersRes.status === 200 && teachersRes.data['success']) {
                    const activeTeachers = teachersRes.data.data
                        .filter(t => t.isDeleted === false)
                        .map(t => ({
                            id: t.id,
                            fullName: t.fullName
                        }));
                    setTeachers(activeTeachers);
                } else {
                    setMsg(teachersRes.data['message']);
                }
            } catch (err) {
                setMsg("Veriler yüklenirken bir hata oluştu.");
            } finally {
                setLoading(false);
            }
        };

        fetchInitialData();
    }, [user.token]);

    return (
        <div className="container-fluid py-4">
            <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-8 col-xl-6">

                    {msg && <div className="alert alert-warning text-center shadow-sm">{msg}</div>}

                    <div className="card shadow border-0 rounded-3">
                        <div className="card-header bg-primary text-white text-center py-3 border-0 rounded-top">
                            <h3 className="mb-0 fw-bold">{t("createclass")}</h3>
                        </div>

                        <div className="card-body p-4 p-md-5">
                            {loading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Yükleniyor...</span>
                                    </div>
                                    <p className="mt-3 text-muted fw-semibold">Veriler Yükleniyor, Lütfen Bekleyiniz...</p>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-4">
                                        <label htmlFor="className" className="form-label fw-bold text-secondary"> {t('className')} </label>
                                        <input
                                            type="text"
                                            className="form-control form-control-lg bg-light"
                                            name="className"
                                            id="className"
                                            value={formData.className}
                                            onChange={handleInputChange}
                                            placeholder="Örn: 12-A Sınıfı"
                                            required
                                        />
                                    </div>

                                    <div className="mb-4">
                                        <label htmlFor="description" className="form-label fw-bold text-secondary"> {t('classdescription')} </label>
                                        <textarea
                                            className="form-control bg-light"
                                            name="description"
                                            id="description"
                                            rows="3"
                                            value={formData.description}
                                            onChange={handleInputChange}
                                            placeholder="Sınıf hakkında kısa bir açıklama giriniz..."
                                            required
                                        />
                                    </div>

                                    <div className="mb-4">
                                        <label htmlFor="lecturerId" className="form-label fw-bold text-secondary">{t('teacherId')}</label>
                                        <select
                                            id="lecturerId"
                                            name="lecturerId"
                                            className="form-select form-select-lg bg-light"
                                            value={formData.lecturerId}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="" disabled>{t('pleaseselectteacher')}</option>
                                            {teachers.map((dt) => (
                                                <option key={dt.id} value={dt.id}>{dt.fullName}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="mb-5">
                                        <label htmlFor="sectionId" className="form-label fw-bold text-secondary">{t('selectSection')}</label>
                                        <select
                                            id="sectionId"
                                            name="sectionId"
                                            className="form-select form-select-lg bg-light"
                                            value={formData.sectionId}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="" disabled>{t('selectSection')}</option>
                                            {sections.map((dt) => (
                                                <option key={dt.id} value={dt.id}>
                                                    {dt.sectionName} {dt.sectionDescription ? `- ${dt.sectionDescription}` : ""}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="d-grid gap-2">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-lg py-3 fw-bold shadow-sm"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? (
                                                <span><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> Kaydediliyor...</span>
                                            ) : (
                                                <> <i className="bi bi-plus-circle me-2"></i> {t('create')} </>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ManagerCreateClass;